export enum AircraftUnderMaintenanceType {
  GroupName = "AircraftUnderMaintenanceType",
  Redeliver = 1,
  CCheck = 2,
}
export enum AircraftUnderMaintenanceStatus {
  GroupName = "AircraftUnderMaintenanceStatus",
  Open = 1,
  Accepted = 2,
  Cancelled = 3,
}
